module.exports = __webpack_public_path__ + "img/main_pc.12e62544.jpg";